import { render } from "./ServerImage.vue?vue&type=template&id=be92e2fe&scoped=true"
import script from "./ServerImage.vue?vue&type=script&lang=js"
export * from "./ServerImage.vue?vue&type=script&lang=js"

import "../../assets/scss/document_thumbnails.scss?vue&type=style&index=0&id=be92e2fe&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be92e2fe"]])

export default __exports__